import Vue from 'vue';
import Core from '@/core/st.core';

Vue.use(Core);

export default Core;
